import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme
} from "@mui/material";

export type DadoIcms = {
  mes: string;
  "ICMS a Recolher": number;
};

const EvolucaoIcmsChart = ({
  endpoint,
  title
}: {
  endpoint: string;
  title: string;
}) => {
  const [dados, setDados] = useState<DadoIcms[]>([]);
  const theme = useTheme();

  useEffect(() => {
    const fetchData = async () => {
      const token = document.cookie
        .split("; ")
        .find((row) => row.startsWith("authTokenMHP="))
        ?.split("=")[1];

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}sped-fiscal/${endpoint}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
          }
        }
      );

      if (!response.ok) {
        // 422 normalmente indica que o usuário não possui estabelecimento vinculado
        if (response.status === 422) {
          setDados([]); // mantém o componente mas sem dados
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // garante que data.data exista e seja iterável
      const transformado = Array.isArray(data.data)
        ? data.data.map((item: any) => ({
            mes: item["MÊS"],
            "ICMS a Recolher": item["VALOR ICMS A RECOLHER"]
          }))
        : Object.values(data.data ?? {}).map((item: any) => ({
        mes: item["MÊS"],
        "ICMS a Recolher": item["VALOR ICMS A RECOLHER"]
      }));

      setDados(transformado);
    };

    fetchData();
  }, [endpoint]);

  return (
    <Card
      sx={{
        p: 2
      }}
    >
      <CardContent sx={{ p: 0, height: 550 }}>
        <Typography
          variant="subtitle1"
          align="center"
          sx={{ color: theme.palette.text.secondary, mb: 2 }}
        >
          {title}
        </Typography>

        <Box height={500}>
          <ResponsiveBar
            data={dados}
            keys={["ICMS a Recolher"]}
            indexBy="mes"
            margin={{ top: 20, right: 20, bottom: 70, left: 80 }}
            padding={0.35}
            colors={theme.palette.error.main}
            borderColor={{ from: "color", modifiers: [["darker", 1.4]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: -40,
              legend: "Mês",
              legendPosition: "middle",
              legendOffset: 50
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              legend: "Valor (R$)",
              legendPosition: "middle",
              legendOffset: -60
            }}
            enableLabel={false}
            valueFormat={(value) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL"
              }).format(value as number)
            }
            tooltip={({ value, id }) => (
              <Box
                sx={{
                  background: theme.palette.background.paper,

                  p: 1
                }}
              >
                <Typography variant="body2" fontWeight={500}>
                  {id}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                  }).format(value as number)}
                </Typography>
              </Box>
            )}
            animate
            motionConfig="gentle"
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default EvolucaoIcmsChart;
